<template>
	<div
		class="notifications-toolbar flex"
		:class="{ 'justify-between': hasNotifications, 'justify-end': !hasNotifications }"
	>
		<n-button v-if="hasNotifications" quaternary @click="deleteAll()">{{ t('clear') }}</n-button>
		<n-button strong secondary type="primary" :disabled="!hasUnread" @click="setAllRead()">
			{{ t('mark_all_as_read') }}
		</n-button>
	</div>
</template>

<script lang="ts" setup>
import { NButton } from "naive-ui"
import { useNotificationsStore } from "@/stores/useNotificationsStore"
import {useStoreI18n} from "@/composables/useStoreI18n"

const hasUnread = useNotificationsStore().hasUnread
const hasNotifications = useNotificationsStore().hasNotifications
const {t} = useStoreI18n()

function setAllRead() {
  useNotificationsStore().setAllRead()
}

function deleteAll() {
  useNotificationsStore().deleteAll()
}
</script>

<style>
.notifications-toolbar {
	width: 100%;
}
</style>
